import { useEffect, useState } from 'react'

// true on phones AND iPads (below 1024px: 768-1023 is iPad portrait / split view, which works like the phone) and in the
// installed app (standalone). The one phone breakpoint of the app: every phone media query is (max-width: 1023px) (ipad).
export const PHONE_MAX = 1023
export const PHONE_MQ = '(max-width: 1023px), (display-mode: standalone)'
export const isPhoneNow = () => typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(PHONE_MQ).matches

export function usePhone() {
  const [phone, setPhone] = useState(isPhoneNow)
  useEffect(() => {
    if (!window.matchMedia) return
    const mq = window.matchMedia(PHONE_MQ), on = () => setPhone(mq.matches)
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on)
    return () => { mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on) }
  }, [])
  return phone
}
